import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { userService } from 'services';
import { useErrorState, useToastState } from 'shared';
import { PhoneNumberForm } from 'components/login';

export const PhoneNumberPage = props => {
    const { handleError } = useErrorState();
    const locationState = props?.location?.state;
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const linkToLogin = () => history.replace('/login');
    const verifyNumber = async payload => {
        setLoading(true);
        try {
            await userService.submitPhone(payload);
            // if the users password has expired then they will be routed to the set password page to set a new password
            history.push('/verify', { ...locationState, ...payload });
        } catch (error) {
            handleError(error);
        }
        setLoading(false);
    };
    return (
        <div className="login-wrap">
            <div className="login-card">
                <div className="logo">
                    <img src="/logo-chedss.png" alt="CHEDSS" />
                    <h2 className="text-center my-5">Data Submission System (CHEDSS)</h2>
                    <PhoneNumberForm
                        loading={loading}
                        onSubmit={verifyNumber}
                        linkToLogin={linkToLogin}
                    />
                </div>
            </div>
        </div>
    );
};
